// import logo from "./logo.svg";
import "./styles/App.css";

import React, { useEffect, useState, useMemo, useRef } from "react";
import Axios from "axios";

import { Footer } from "./components/shared/footer";
import { NavBar } from "./components/shared/navbar";
import { Loading } from "./components/shared/loading";
import { CustomCursor } from "./components/shared/CustomCursor";
import { ToastProvider } from "./components/shared/Toast";
import { Login } from "./pages/admin/login";
import { UserRoutes } from "./routes/UserRoutes";
import { AdminRoutes } from "./routes/AdminRoutes";

import { UserContext } from "./contexts/UserContext";
import {
  MuiThemeProvider,
  Fab,
  Zoom,
  useScrollTrigger,
  makeStyles,
} from "@material-ui/core";

import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import { HelmetProvider } from "react-helmet-async";
// import "@fontsource/poppins"; 

import { theme } from "./styles/theme";
import { HEAD_KEY } from "./utils/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(7),
  },
}));

function ScrollTop(props) {
  const { children, window, topRef } = props;
  const classes = useStyles();

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    
    // const anchor = (event.target.ownerDocument || document).querySelector(
    //   "#back-to-top-anchor"
    // );

    // if (anchor) {
    //   anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    // }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

const App = (props) => {
  const [isloading, setIsloading] = useState(true);
  const [user, setUser] = useState();

  const topOfPageRef = useRef(null);

  const value = useMemo(() => ({ user, setUser }), [user, setUser]);

  useEffect(() => {
    Axios.get("/api/checksession", {
      headers: { headKey: HEAD_KEY },
    }).then((res) => {
      if (res.data.status) {
        setUser(res.data.userdata);
        setIsloading(false);
      } else {
        setUser(null);
        setIsloading(false);
      }
    });
  }, []);

  return (
    <HelmetProvider>
      <MuiThemeProvider theme={theme}>
        <ToastProvider>
        <CustomCursor />
        <div className="App" style={{ fontFamily: "Poppins !important" }} ref={topOfPageRef}>
          {isloading ? (
            <Loading />
          ) : (
            <UserContext.Provider value={value}>
              <div className="page-container">
                <Router>
                  <NavBar />
                  <div class="content-wrap">
                    <Routes>
                      <Route
                        path="/login_ad"
                        element={user ? <Navigate to="/dash" /> : <Login />}
                      />
                      <Route path="/*" element={<UserRoutes />} />
                      <Route
                        path="/dash/*"
                        element={user ? <AdminRoutes /> : <Navigate to="/" />}
                      />
                      <Route path="*" element={<Navigate to="/" />}/>
                    </Routes>
                  </div>

                  <Footer />
                  <ScrollTop {...props} topRef={topOfPageRef}>
                    <Fab
                      color="primary"
                      aria-label="scroll back to top"
                      style={{ border: "1px solid white" }}
                    >
                      <KeyboardArrowUpIcon />
                    </Fab>
                  </ScrollTop>
                </Router>
              </div>
            </UserContext.Provider>
          )}
        </div>
        </ToastProvider>
      </MuiThemeProvider>
    </HelmetProvider>
  );
};

export default App;
